import { onClickWhatsapp } from './clickEvents.js'
import { loadCards } from './domStructure/doorWindowsCards.js'
// import { populateWindowAccordionList } from './domStructure/windowComponentAccordion.js'
import { createBannerComponent } from './domStructure/generics.js'
import { createCopyrightAndCreatorSection } from './domStructure/footer.js'
// import { resizeWindowHandler } from './utils/windowResize.js'

window.onload=function() {
    createBannerComponent("WINDOWS", "h1", document.querySelector('#bannerId'))
    // populateWindowAccordionList(document.querySelector("#windowsComponents"), `${fantastic_windows_vars.api_url}/assets/JSON/windowsComponent.json`)
    const NUM_WINDOWS = 8
    const WINDOW_ID_PREFIX = 'windowCardType'
    const sectionWindows = document.querySelector('#windowTypes')
    const colWindowClassList = ["col-md-6", "col-lg-3"]
    const windowsCardObj = {cardTypePrefix: WINDOW_ID_PREFIX, numCards: NUM_WINDOWS, classList: ["card-my3"]}
    loadCards(sectionWindows, colWindowClassList, windowsCardObj, `${fantastic_windows_vars.api_url}/assets/JSON/windows.json`, true, "windows")

    const NUM_GLASSES = 8
    const GLASS_ID_PREFIX = 'glassCardType'
    const sectionGlasses = document.querySelector('#glassTypes')
    const colGlassClassList = ["col-lg-3", "col-md-6"]
    const glassesCardObj = {cardTypePrefix: GLASS_ID_PREFIX, numCards: NUM_GLASSES, classList: ["card-my3"]}
    loadCards(sectionGlasses, colGlassClassList, glassesCardObj, `${fantastic_windows_vars.api_url}/assets/JSON/glasses.json`, true, "glasses")

    const copyrightAndCreatorsJson = ""
    const copyrightAndCreatorSection = document.querySelector('#copyright-and-creators-id')
    createCopyrightAndCreatorSection(copyrightAndCreatorSection, copyrightAndCreatorsJson)
}

document.querySelector('#whatsapp-icon').addEventListener('click', (e) => {
    onClickWhatsapp()
})


const $dropdown = $(".dropdown")
const $dropdownToggle = $(".dropdown-toggle")
const $dropdownMenu = $(".dropdown-menu")
const showClass = "show"
// $(window).on("load resize", function() {
//     resizeWindowHandler(this, $(this), $dropdown, $dropdownToggle, $dropdownMenu, showClass)
// })
$(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 768px)").matches) {
        $dropdown.hover(
            function() {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "true");
                $this.find($dropdownMenu).addClass(showClass);
            },
            function() {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "false");
                $this.find($dropdownMenu).removeClass(showClass);
            }
        )
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
})